import SimilarTitle from '../models/SimilarTitle';

export function getSimilarTitles(store) {
    let retval = [];
    const similarTitles = store.FeatureContent && store.FeatureContent.SimilarTitles;
    if (similarTitles) {
        const data = similarTitles.titles;
        if (data != null && data.length > 0) {
            retval = data.map((similarTitle) => {
                return new SimilarTitle(similarTitle);
            });
        }
    }
	return retval;
}



// WEBPACK FOOTER //
// ./src/data/SimilarTitleSelectors.js